import { render, staticRenderFns } from "./RadioButton.vue?vue&type=template&id=7aa490c0&scoped=true&"
import script from "./RadioButton.vue?vue&type=script&lang=ts&"
export * from "./RadioButton.vue?vue&type=script&lang=ts&"
import style0 from "./RadioButton.vue?vue&type=style&index=0&id=7aa490c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa490c0",
  null
  
)

export default component.exports